import React from 'react';
import { Col, Row, Button, Space } from 'antd';



class LoggerDemoView extends React.Component {


    render() {
        const logger = window.CyaLogger;
        return <>
            <Row>
                <Col flex="auto"></Col>
                <Col>
                    <h1>集团通用埋点测试页</h1>
                </Col>
                <Col flex="auto"></Col>
            </Row>
            <Row>
                <Col offset={1} span={2} style={{ alignSelf: 'center' }}>
                    <span>点击事件:</span>
                </Col>
                <Col>
                    <Space>
                        <Button
                            onClick={() => logger.sendClick(null, 'demo_click_1', { value: {} })}
                        >按钮1</Button>
                        <Button
                            onClick={() => logger.sendClick(null, 'demo_click_2', { value: {} })}
                        >按钮2</Button>
                        <Button
                            onClick={() => logger.sendClick(null, 'demo_click_3', { value: {} })}
                        >按钮3</Button>
                        <Button
                            onClick={() => logger.sendClick(null, 'demo_click_4', { value: {} })}
                        >按钮4</Button>
                    </Space>
                </Col>
            </Row>
            <div style={{height: 20}} />
            <Row>
                <Col offset={1} span={2} style={{ alignSelf: 'center' }}>
                    <span>曝光事件:</span>
                </Col>
                <Col>
                    <Space>
                        <Button
                            onClick={() => logger.sendImp(null, 'demo_img_1', { value: {} })}
                        >曝光1</Button>
                        <Button
                            onClick={() => logger.sendImp(null, 'demo_img_2', { value: {} })}
                        >曝光2</Button>
                        <Button
                            onClick={() => logger.sendImp(null, 'demo_img_3', { value: {} })}
                        >曝光3</Button>
                        <Button
                            onClick={() => logger.sendImp(null, 'demo_img_4', { value: {} })}
                        >曝光4</Button>
                    </Space>
                </Col>
            </Row>
            <div style={{height: 20}} />
            <Row>
                <Col offset={1} span={2} style={{ alignSelf: 'center' }}>
                    <span>加购事件:</span>
                </Col>
                <Col>
                    <Space>
                        <Button
                            onClick={() => logger.sendAddCart(null, 'demo_addcart', { product_id: '10000', value: {} })}
                        >加购10000</Button>
                        <Button
                            onClick={() => logger.sendAddCart(null, 'demo_addcart', { product_id: '10010', value: {} })}
                        >加购10010</Button>
                        <Button
                            onClick={() => logger.sendAddCart(null, 'demo_addcart', { product_id: '10020', value: {} })}
                        >加购10020</Button>
                        <Button
                            onClick={() => logger.sendAddCart(null, 'demo_addcart', { product_id: '10030', value: {} })}
                        >加购10030</Button>
                    </Space>
                </Col>
            </Row>
            <div style={{height: 20}} />
            <Row>
                <Col offset={1} span={2} style={{ alignSelf: 'center' }}>
                    <span>下单事件:</span>
                </Col>
                <Col>
                    <Space>
                        <Button
                            onClick={() => logger.sendOrder(null, 'demo_order', { order_id: '10000', value: {pay_price: 188, pay_method: 'alipay'} })}
                        >下单10000</Button>
                        <Button
                            onClick={() => logger.sendOrder(null, 'demo_order', { order_id: '10010', value: {pay_price: 288, pay_method: 'wxpay'} })}
                        >下单10010</Button>
                        <Button
                            onClick={() => logger.sendOrder(null, 'demo_order', { order_id: '10020', value: {pay_price: 988, pay_method: 'apple-pay'} })}
                        >下单10020</Button>
                        <Button
                            onClick={() => logger.sendOrder(null, 'demo_order', { order_id: '10030', value: {pay_price: 1888, pay_method: 'card'} })}
                        >下单10030</Button>
                    </Space>
                </Col>
            </Row>
            <div style={{height: 20}} />
            <Row>
                <Col offset={1} span={2} style={{ alignSelf: 'center' }}>
                    <span>自定义事件:</span>
                </Col>
                <Col>
                    <Space>
                        <Button
                            onClick={() => logger.sendCustomEvent('custom_event', null, 'custom_event_1', {})}
                        >自定义1</Button>
                        <Button
                            onClick={() => logger.sendCustomEvent('custom_event', null, 'custom_event_2', {context: 'test'})}
                        >自定义2</Button>
                        <Button
                            onClick={() => logger.sendCustomEvent('custom_event', null, 'custom_event_3')}
                        >自定义3</Button>
                        <Button
                            onClick={() => logger.sendCustomEvent('custom_event', null, 'custom_event_4')}
                        >自定义4</Button>
                    </Space>
                </Col>
            </Row>
            <div style={{height: 20}} />
            <Row>
                <Col offset={1} span={2} style={{ alignSelf: 'center' }}>
                    <span>设置utm_campaign:</span>
                </Col>
                <Col>
                    <Space>
                        <Button
                            onClick={() => logger.setUtmCampaign('baidu=ad12121')}
                        >baidu=ad12121</Button>
                        <Button
                            onClick={() => logger.setUtmCampaign('google=ad12121')}
                        >google=ad12121</Button>
                        <Button
                            onClick={() => logger.setUtmCampaign('bcz=ad22222')}
                        >bcz=ad22222</Button>
                        <Button
                            onClick={() => logger.setUtmCampaign('god=ad3333')}
                        >god=ad3333</Button>
                    </Space>
                </Col>
            </Row>
        </>
    }
}

export default LoggerDemoView;